import * as React from "react";

import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { Button } from "grommet";
import { FaHourglass } from "react-icons/fa6";
import SkeletonWrapper from "../components/SkeltonWrapper";

export const SignInButton = () => {
    const { instance } = useMsal();
    const [loading, setLoading] = React.useState(false);
    const handleLogin = () => {
        setLoading(true);
        instance.loginRedirect({ ...loginRequest, tokenQueryParameters: { context: DefaultOrganization }, extraQueryParameters: { context: DefaultOrganization } });
    };

    // React.useEffect(() => {
    //     let account = instance.getActiveAccount();
    //     if (!account) {
    //         instance.ssoSilent(loginRequest);
    //     }
    // }, []);

    return (
        <div>
            <SkeletonWrapper loading={loading}>
                <Button onClick={() => handleLogin()} key="loginRedirect" label={"Login"}></Button>
            </SkeletonWrapper>
        </div>
    );
};
